import { QuizConfig, QuizResultTier } from '../types/quiz';

export function calculateScore(answers: boolean[], quiz: QuizConfig): number {
  return answers.reduce((sum, isYes, index) => {
    if (index >= quiz.questions.length) return sum;
    const q = quiz.questions[index];
    return sum + (isYes ? q.yesScore : q.noScore);
  }, 0);
}

export function getResultValue(score: number, quiz: QuizConfig): number {
  return quiz.baseValue + score;
}

export function getResultTier(score: number, quiz: QuizConfig): QuizResultTier {
  for (const tier of quiz.resultTiers) {
    if (score <= tier.maxScore) return tier;
  }
  return quiz.resultTiers[quiz.resultTiers.length - 1];
}

export function getPercentileForQuiz(score: number, mean: number, sd: number): number {
  const z = (score - mean) / sd;
  const t = 1 / (1 + 0.2316419 * Math.abs(z));
  const d = 0.3989422804014327;
  const p =
    d *
    Math.exp((-z * z) / 2) *
    (t * (0.3193815 + t * (-0.3565638 + t * (1.781478 + t * (-1.821256 + t * 1.3302744)))));
  const percentile = z > 0 ? (1 - p) * 100 : p * 100;
  return Math.round(Math.min(99, Math.max(1, percentile)));
}
